export const TOTAL_NUMBER_OF_SKILLS_TO_SHOW = 12;
